import api from './index';
import { ENDPOINTS } from './endpoints';

export const getNavMenus = () => api.get(ENDPOINTS.NAV_MENUS);
